export enum EnumToastVariant{
    Primary="primary",
    Success="success",
    Info="info",
    Danger="danger",
    Warning="warining"
}

export enum EnumToastMessage{
    AmbassadorApprove = "Ambassador Approved",
    AmbassadorReject = "Ambassador Rejected",
}